import {Component} from '@angular/core';
/**
 * \@title Basic grid-list
 */
export class GridListOverviewExample {static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'grid-list-overview-example',
  styleUrls: ['grid-list-overview-example.css'],
  templateUrl: 'grid-list-overview-example.html',
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function GridListOverviewExample_tsickle_Closure_declarations() {
/** @type {?} */
GridListOverviewExample.decorators;
/**
 * @nocollapse
 * @type {?}
 */
GridListOverviewExample.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
